import { useEffect } from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Cookie, X, Settings2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { CookiePreferencesModal } from "./CookiePreferencesModal";

export const CookieConsent = () => {
  const {
    preferences,
    showBanner,
    showModal,
    acceptAll,
    rejectNonEssential,
    savePreferences,
    openPreferences,
    closePreferences,
    setShowBanner,
  } = useCookieConsent();

  // Listen for custom event to open preferences modal (from cookie policy page)
  useEffect(() => {
    const handleOpenPreferences = () => {
      openPreferences();
    };

    window.addEventListener('openCookiePreferences', handleOpenPreferences);
    return () => {
      window.removeEventListener('openCookiePreferences', handleOpenPreferences);
    };
  }, [openPreferences]);

  return (
    <>
      {/* Cookie Banner */}
      {showBanner && !showModal && (
        <div 
          className="fixed bottom-4 left-4 right-4 z-[99999] animate-fade-in pointer-events-auto"
          style={{ position: 'fixed', zIndex: 99999 }}
        >
          <Card className="bg-deep-navy border-neon-glow/30 max-w-xl mx-auto md:mx-4 shadow-[0_0_30px_rgba(45,184,255,0.3)] pointer-events-auto">
            <CardContent className="p-4 md:p-5">
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-full bg-gradient-to-br from-neon-glow/30 to-radiant-blue/20 flex items-center justify-center flex-shrink-0 shadow-[0_0_15px_rgba(45,184,255,0.3)]">
                  <Cookie className="h-4 w-4 text-neon-glow" />
                </div>
                
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-300 leading-relaxed mb-3">
                    This website uses cookies to improve your experience, enhance security, and analyze traffic. 
                    You can choose which cookies to allow.{" "}
                    <Link to="/cookie-policy" className="text-neon-glow hover:underline">
                      Learn more
                    </Link>
                  </p>
                  
                  <div className="flex flex-wrap gap-2">
                    <Button
                      onClick={acceptAll}
                      size="sm"
                      className="bg-gradient-to-r from-neon-glow to-radiant-blue hover:opacity-90 text-deep-navy font-semibold text-xs h-8"
                    >
                      Accept All
                    </Button>
                    <Button
                      onClick={rejectNonEssential}
                      size="sm"
                      variant="outline"
                      className="border-neon-glow/40 hover:border-neon-glow text-white text-xs h-8"
                    >
                      Reject Non-Essential
                    </Button>
                    <Button
                      onClick={openPreferences}
                      size="sm"
                      variant="ghost"
                      className="text-gray-400 hover:text-white text-xs h-8"
                    >
                      <Settings2 className="h-3 w-3 mr-1" />
                      Manage
                    </Button>
                  </div>
                </div>

                <button
                  onClick={rejectNonEssential}
                  className="text-gray-500 hover:text-white transition-colors flex-shrink-0 p-1"
                  aria-label="Close cookie banner"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Cookie Preferences Modal */}
      <CookiePreferencesModal
        isOpen={showModal}
        onClose={closePreferences}
        onSave={savePreferences}
        currentPreferences={preferences}
      />
    </>
  );
};
